export const axios = require('axios');

export const config = {
	// api: 'https://my-json-server.typicode.com/susanBuck/e28/',
	api: '/techniques.js'
}
